module.exports = __webpack_public_path__ + "static/Customcounsellormatchcard-9fd7fb60654a53a2a06e90e512c050e2.png";